import type { AuthUser } from "../../../stores/useAuthStore";

function readString(value: unknown): string {
  return typeof value === "string" ? value.trim() : "";
}

/** The user's real full name, or "" when they don't have one. */
export function getUserFullName(user: AuthUser | null | undefined): string {
  if (!user) return "";
  return readString(user.full_name) || readString(user.fullName);
}

/**
 * The name to show for a user: their full name, else their email, else "".
 * Never a made-up placeholder — a fake name or email reads as a real,
 * different account.
 */
export function getUserDisplayName(user: AuthUser | null | undefined): string {
  if (!user) return "";
  return getUserFullName(user) || readString(user.email);
}

/**
 * Avatar initials for a display name: up to two initials for a name, the
 * first letter for an email, "" when there's nothing to show (callers
 * render a generic icon instead).
 */
export function getUserInitials(displayName: string): string {
  const trimmed = displayName.trim();
  if (!trimmed) return "";
  if (trimmed.includes("@")) return trimmed.charAt(0).toUpperCase();
  return trimmed
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
}
